<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Marcas</div>
                <div class="text text--thin mb-2">As marcas incluídas aqui são exibidas no cadastro de produtos</div>
                <v-btn v-if="$root.Permissions.admin()" @click="dialogNovo = true" color="primary" class="mt-1"><v-icon class="mr-1">add_moderator</v-icon>Nova marca</v-btn>
              </v-col>
              <v-col cols="12" md="5" v-if="$root.Permissions.admin()">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        multi-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <v-row no-gutters>
              <div class="py-2 px-2">
                <v-text-field
                  clearable
                  hide-details=""
                  clear-icon="close"
                  v-model="search"
                  outlined
                  label="Busca"
                ></v-text-field>
              </div>
            </v-row>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.mar_imagem="{ item }">
          <img v-if="item.mar_imagem" class="marca_logo" :src="item.mar_imagem" :alt="item.mar_nome">
          <div v-else>Não possui</div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{marca.uuid_mar_id ? 'Editar marca' : 'Nova marca'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formMarcas">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="marca.mar_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="marca.mar_imagem"
                prepend-icon="image"
                label="Adicionar logotipo*"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                :rules="[rules.size]"
                hint="Tamanho recomendado: 300x300px"
                persistent-hint
                v-if="isObject(marca.mar_imagem)"
                outlined
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="marca.mar_imagem && !isObject(marca.mar_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div v-if="marca.mar_imagem">
                  <img alt="Logotipo" :src="marca.mar_imagem" class="logotipo">
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover logotipo</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditMarcas()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Logotipo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover o logotipo?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Marca
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelMarcaDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir marca <b class="text-primary">{{marca ? marca.mar_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelMarcaDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeMarca()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogDeletarImagem: false,
      search: '',
      searchField: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'mar_id',
          width: 150
        },
        { text: 'Nome', value: 'mar_nome' },
        { text: 'Imagem', value: 'mar_imagem' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!'
      },
      marca: {
        mar_nome: '',
        mar_imagem: ''
      }
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(),
        busca: this.search,
        type: 'marcas'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      this.getMarcas()
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getMarcas () {
      this.loading = true
      await Api.get('marcas')
        .then(res => {
          if (res.data) {
            let info = []
            if (res.data.length > 0) {
              res.data.map(item => {
                info.push({
                  uuid_mar_id: item.uuid_mar_id,
                  mar_id: item.mar_id,
                  mar_nome: item.mar_nome,
                  mar_imagem: item.mar_imagem
                })
              })
            }
            this.dados = info
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as marcas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeImagem () {
      this.marca.mar_imagem = ''
      this.marca.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    saveEditMarcas () {
      if (!this.$refs.formMarcas.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'marcas/novo'
      let editado = false
      if (this.marca.uuid_mar_id) {
        endpoint = 'marcas/edita'
        editado = true
      }
      const formData = new FormData()
      Object.keys(this.marca).map((key) => {
        if (key === 'mar_imagem') {
          if (this.$refs.file) {
            formData.append(`mar_imagem`, this.marca.mar_imagem)
          }
        } else {
          if (this.marca[key] != null) {
            formData.append(key, this.marca[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Marca atualizado com sucesso!' : 'Marca cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getMarcas()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeMarca () {
      this.salvando = true
      console.log(this.marca)
      Api.delete(`marcas/remove/${this.marca.uuid_mar_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getMarcas()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover marca!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.marca = JSON.parse(JSON.stringify(item))
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.marca = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelMarcaDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.marca = {
        mar_nome: '',
        mar_imagem: ''
      }
      if (this.$refs.formMarcas) {
        this.$refs.formMarcas.resetValidation()
      }
      this.dialogNovo = false
    },
    verifyPermissions () {
      if (this.$root.Permissions.admin()) return true
      this.headers.pop()
    }
  },
  created () {
    this.verifyPermissions()
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.logotipo {
  max-height: 250px;
  max-width: 250px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
.marca_logo {
  max-height: 100px;
  margin: 5px 0;
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Marcas.vue